import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import pathRouts from '../enums/pathRoute';
import verbsTypes from '../enums/verbsTypes';
import { reportLmsAction } from '../utils/reportLmsAction';

const useLmsAction = (objectId, objectName, isAppLevel = false) => {
    //   const [startTime, setStartTime] = useState(null);
    const { isAuth } = useSelector(state => state.auth);

    useEffect(() => {
        if (isRouteShouldFetch() && isAuth) {
            const startTime = Date.now();

            const handleEnter = async () => {
                await reportLmsAction(verbsTypes.ENTER, objectId, null, objectName);
            };

            const handleExit = () => {
                const endTime = Date.now();
                const durationInSeconds = Math.round((endTime - startTime) / 1000);

                reportLmsAction(verbsTypes.EXIT, objectId, durationInSeconds, objectName);
            };

            handleEnter();



            if (isAppLevel) {
                window.addEventListener('beforeunload', handleExit);
            }

            return () => {
                if (isAppLevel) {
                    window.removeEventListener('beforeunload', handleExit);
                } else if (startTime) {
                    handleExit();
                }
            };
        }
        //react-hooks/exhaustive-deps
    }, [objectId, isAppLevel, objectName,isAuth]);
};

export default useLmsAction;

const isRouteShouldFetch = () => {
    return !window.location.pathname.includes(pathRouts.DELAYNAVIGATE.route)
}